import React, { useEffect, useState } from 'react';

export default function ClientFormsPage() {

    const caseId = localStorage.getItem('clientCaseId');
  const [dockets, setDockets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const token = localStorage.getItem("clientToken");
    const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    fetch(`${API_URL}/case/${caseId}/dockets/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(data => {
        setDockets(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [caseId]);

  if (loading) return <div className="p-4">Loading dockets...</div>;
  if (error) return <div className="p-4 text-red-600">Error: {error}</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-indigo-700 mb-4">📝 Bankruptcy Forms</h1>
      <p className="text-gray-600 mb-6">
        Here you'll find the official forms signed and filed in your case as well as other important docket entries.
      </p>

      <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Docket Entries</h1>
            {dockets.length === 0 ? (
              <p className="text-gray-600">No dockets found for this case.</p>
            ) : (
              dockets.map(entry => (
                <div key={entry.id} className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <h2 className="text-xl font-semibold mb-1">
                      Docket #{entry.docket_number}
                    </h2>
                    <p className="text-gray-500 mb-2">
                      Filed: {new Date(entry.filed_at).toLocaleDateString()}
                    </p>
                    <p className="text-gray-700 mb-4">{entry.docket_text}</p>
                    <div className="flex flex-col space-y-2">
                      {entry.documents.map(doc => (
                        <a
                          key={doc.id}
                          href={doc.file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        >
                          {doc.description || 'Download PDF'}
                        </a>
                      ))}
                    </div>
                </div>
              ))
            )}
          </div>

    </div>
  );
}